// theme error handler
(function() {
 // ✅ Przechwytuj nieobsłużone błędy JavaScript
 window.addEventListener('error', function(event) {
 const error = event.error || event;
 const errorMessage = error.message || event.message || 'Unknown error';
 const errorStack = error.stack || '';
 
 // ✅ Sprawdź czy to błąd z motywu Shopify (aspectRatioHelper, processNewElements)
 const isThemeError = 
 errorMessage.includes('aspectRatioHelper') ||
 errorMessage.includes('processNewElements') ||
 errorMessage.includes('#aspectRatioHelper') ||
 errorStack.includes('aspectRatioHelper') ||
 errorStack.includes('processNewElements');
 
 if (isThemeError) {
 // ✅ Zapobiegaj crashowi - loguj do Sentry ale nie przerywaj działania
 console.warn('⚠️ [THEME-ERROR-HANDLER] Przechwycono błąd z motywu Shopify:', errorMessage);
 
 // ✅ Loguj do Sentry z pełnym kontekstem
 if (typeof Sentry !== 'undefined' && window.__sentryInitialized) {
 Sentry.withScope((scope) => {
 scope.setTag('customify', 'true');
 scope.setTag('error_type', 'theme_error');
 scope.setTag('error_source', 'shopify_theme');
 scope.setTag('theme_component', 'aspectRatioHelper');
 scope.setContext('theme_error', {
 errorMessage: errorMessage,
 errorStack: errorStack.substring(0, 1000), // Max 1000 chars
 url: window.location.href,
 userAgent: navigator.userAgent,
 timestamp: new Date().toISOString()
 });
 Sentry.captureException(error);
 });
 }
 
 // ✅ Zapobiegaj domyślnemu zachowaniu (nie pokazuj w konsoli jako nieobsłużony błąd)
 event.preventDefault();
 return false;
 }
 
 // ✅ Dla innych błędów - pozwól Sentry je obsłużyć normalnie
 return true;
 }, true); // useCapture = true (przechwytuj PRZED innymi handlerami)
 
 // ✅ Przechwytuj nieobsłużone promise rejections
 window.addEventListener('unhandledrejection', function(event) {
 const error = event.reason || event;
 const errorMessage = error?.message || String(error) || 'Unknown promise rejection';
 const errorStack = error?.stack || '';
 
 // ✅ Sprawdź czy to błąd z motywu Shopify
 const isThemeError = 
 errorMessage.includes('aspectRatioHelper') ||
 errorMessage.includes('processNewElements') ||
 errorMessage.includes('#aspectRatioHelper') ||
 errorStack.includes('aspectRatioHelper') ||
 errorStack.includes('processNewElements');
 
 if (isThemeError) {
 console.warn('⚠️ [THEME-ERROR-HANDLER] Przechwycono promise rejection z motywu Shopify:', errorMessage);
 
 // ✅ Loguj do Sentry
 if (typeof Sentry !== 'undefined' && window.__sentryInitialized) {
 Sentry.withScope((scope) => {
 scope.setTag('customify', 'true');
 scope.setTag('error_type', 'theme_promise_rejection');
 scope.setTag('error_source', 'shopify_theme');
 scope.setTag('theme_component', 'aspectRatioHelper');
 scope.setContext('theme_error', {
 errorMessage: errorMessage,
 errorStack: errorStack.substring(0, 1000),
 url: window.location.href,
 timestamp: new Date().toISOString()
 });
 Sentry.captureException(error);
 });
 }
 
 // ✅ Zapobiegaj domyślnemu zachowaniu
 event.preventDefault();
 }
 });
 
 console.log('✅ [THEME-ERROR-HANDLER] Global error handler zainstalowany');
 
 // ✅ VIEW TRANSITION ERROR HANDLER - Ignoruj błędy animacji (nieistotne)
 // Błędy view transition to tylko animacje przejść między stronami - nie wpływają na funkcjonalność
 window.addEventListener('error', function(event) {
 const error = event.error || event;
 const errorMessage = error.message || event.message || '';
 
 // ✅ Sprawdź czy to błąd view transition
const isViewTransitionError = 
errorMessage.includes('view transition') ||
errorMessage.includes('ViewTransition') ||
errorMessage.includes('skipTransition') ||
errorMessage.includes('Skipping view transition') ||
errorMessage.includes('Transition was aborted') ||
errorMessage.includes('transition was aborted') ||
(error.name === 'AbortError' && errorMessage.includes('transition')) ||
(error.name === 'InvalidStateError' && errorMessage.includes('aborted'));

if (isViewTransitionError) {
// ✅ Ignoruj - to tylko animacje przejść Shopify Horizon (nie wpływają na funkcjonalność)
console.debug('🔇 [VIEW-TRANSITION] Ignoruję błąd animacji:', errorMessage);
event.preventDefault();
return false; // Nie loguj do Sentry
}
 }, true);
 
 // ✅ VIEW TRANSITION PROMISE REJECTION HANDLER
 window.addEventListener('unhandledrejection', function(event) {
 const error = event.reason || event;
 const errorMessage = error?.message || String(error) || '';
 
const isViewTransitionError = 
errorMessage.includes('view transition') ||
errorMessage.includes('ViewTransition') ||
errorMessage.includes('skipTransition') ||
errorMessage.includes('Skipping view transition') ||
errorMessage.includes('Transition was aborted') ||
errorMessage.includes('transition was aborted') ||
(error?.name === 'AbortError' && errorMessage.includes('transition')) ||
(error?.name === 'InvalidStateError' && errorMessage.includes('aborted'));

if (isViewTransitionError) {
// ✅ Ignoruj - to tylko animacje przejść Shopify Horizon (nie wpływają na funkcjonalność)
console.debug('🔇 [VIEW-TRANSITION] Ignoruję promise rejection animacji:', errorMessage);
event.preventDefault();
}
});
 
 console.log('✅ [VIEW-TRANSITION-HANDLER] View transition error handler zainstalowany');
 })();

// collection product hiding
document.addEventListener('DOMContentLoaded', function() {
 // Ukryj produkty z "rozmiar" w URL (kolekcje)
 const rozmiarProducts = document.querySelectorAll('.custom-collection-card[href*="rozmiar"]');
 rozmiarProducts.forEach(product => {
 product.style.display = 'none';
 });
 
 // Ukryj produkty z "cyfrowy" w URL (kolekcje)
 const cyfrowyProducts = document.querySelectorAll('.custom-collection-card[href*="cyfrowy"]');
 cyfrowyProducts.forEach(product => {
 product.style.display = 'none';
 });
 
 const recommendationsRozmiar = document.querySelectorAll('.product-recommendations a[href*="rozmiar"]');
 recommendationsRozmiar.forEach(product => {
 product.style.display = 'none';
 });
 
 // Ukryj produkty z "cyfrowy" w rekomendacjach
 const recommendationsCyfrowy = document.querySelectorAll('.product-recommendations a[href*="cyfrowy"]');
 recommendationsCyfrowy.forEach(product => {
 product.style.display = 'none';
 });
 
 const totalHidden = rozmiarProducts.length + cyfrowyProducts.length + recommendationsRozmiar.length + recommendationsCyfrowy.length;
 console.log('🔒 [PRODUCT HIDING] Ukryto', totalHidden, 'produktów AI (kolekcje + rekomendacje)');
 
 // ✅ NOWE: Dla produktu akwarela (ID: 15475649675589 lub handle zawiera 'akwarela') - ukryj wszystkie style oprócz akwareli
 // WYJĄTEK: obraz-ze-zdjecia-personalizowany-prezent-dla-niej-akwarela ma styl oil-paints (Farby Olejne), NIE akwarela - nie ukrywaj
 if (window.ShopifyProduct && window.ShopifyProduct.handle === 'obraz-ze-zdjecia-personalizowany-prezent-dla-niej-akwarela') {
 return; // Ten produkt ma Farby Olejne - nie uruchamiaj logiki ukrywania
 }
 if (window.ShopifyProduct && (window.ShopifyProduct.id === 15475649675589 || window.ShopifyProduct.id === '15475649675589' || (window.ShopifyProduct.handle && window.ShopifyProduct.handle.includes('akwarela')) || window.location.pathname.includes('akwarela'))) {
 console.log('🎨 [WATERCOLOR] Produkt akwarela wykryty (ID:', window.ShopifyProduct.id, 'handle:', window.ShopifyProduct.handle, ') - ukrywanie wszystkich stylów oprócz akwareli');
 const allStyleCards = document.querySelectorAll('.customify-style-card');
 allStyleCards.forEach(card => {
 const styleName = card.getAttribute('data-style');
 if (styleName && styleName !== 'akwarela') {
 card.style.display = 'none';
 console.log('🔒 [WATERCOLOR] Ukryto styl:', styleName);
 } else if (styleName === 'akwarela') {
 console.log('✅ [WATERCOLOR] Pozostawiono styl akwareli widoczny');
 }
 });
 }
 });

// product gallery and footer policies
// FIX: Przenieś aplikację NATYCHMIAST - eliminuje skakanie
 document.addEventListener('DOMContentLoaded', function() {
 const app = document.getElementById('customify-app-container');
 const prodInfo = document.querySelector('[id^="ProductInformation-"]');
 const placeholder = document.getElementById('customify-placeholder');
 
 if (app && prodInfo) {
 // Dodaj na koniec ProductInformation NATYCHMIAST
 prodInfo.appendChild(app);
 
 // Ukryj placeholder jeśli istnieje
 if (placeholder) {
 placeholder.remove();
 }
 } else {
 // Fallback: jeśli nie ma ProductInformation, spróbuj ponownie po krótkim czasie
 setTimeout(function() {
 const app = document.getElementById('customify-app-container');
 const prodInfo = document.querySelector('[id^="ProductInformation-"]');
 const placeholder = document.getElementById('customify-placeholder');
 
 if (app && prodInfo) {
 prodInfo.appendChild(app);
 if (placeholder) {
 placeholder.remove();
 }
 }
 }, 50);
 }
 });
 
 // FUNKCJA NAPRAWY POWIĘKSZONEGO ZDJĘCIA W DIALOGU
 function fixDialogImages() {
 const dialog = document.querySelector('dialog[open]');
 if (!dialog) return;
 
 // Znajdź wszystkie zdjęcia w dialogu
 const allImages = dialog.querySelectorAll('img');
 let largestImg = null;
 let largestWidth = 0;
 
 allImages.forEach(img => {
 const width = img.clientWidth;
 if (width > largestWidth) {
 largestWidth = width;
 largestImg = img;
 }
 });
 
 if (!largestImg) return;
 
 // Wymuś poprawne style - WYPEŁNIA CAŁY KONTENER
 largestImg.style.setProperty('object-fit', 'cover', 'important');
 largestImg.style.setProperty('max-height', 'none', 'important');
 largestImg.style.setProperty('height', '100%', 'important');
 largestImg.style.setProperty('width', '100%', 'important');
 largestImg.style.setProperty('object-position', 'center', 'important');
 
 // Styluj kontener
 if (largestImg.parentElement) {
 largestImg.parentElement.style.setProperty('height', '100%', 'important');
 }
 
 }
 
 // FUNKCJA UKRYWANIA STAREJ SEKCJI POLITYK
 function hideOldPolicySection() {
 // Ukryj cały popover z politykami
 const policyPopover = document.querySelector('.footer-utilities__group--left anchored-popover-component');
 if (policyPopover) {
 policyPopover.style.display = 'none';
 policyPopover.style.visibility = 'hidden';
 policyPopover.style.opacity = '0';
 policyPopover.style.height = '0';
 policyPopover.style.overflow = 'hidden';
 }
 
 // Ukryj element "Preferencje dotyczące plików cookie"
 const cookieLink = document.querySelector('a[href="/policies/#shopifyReshowConsentBanner"]');
 if (cookieLink) {
 cookieLink.style.display = 'none';
 cookieLink.style.visibility = 'hidden';
 cookieLink.style.opacity = '0';
 cookieLink.style.height = '0';
 cookieLink.style.overflow = 'hidden';
 
 const parentLi = cookieLink.closest('li');
 if (parentLi) {
 parentLi.style.display = 'none';
 parentLi.style.visibility = 'hidden';
 parentLi.style.opacity = '0';
 parentLi.style.height = '0';
 parentLi.style.overflow = 'hidden';
 }
 
 }
 }

 // FUNKCJA DODAWANIA NAWIGACJI NA STRONACH POLITYK
 function addPolicyNavigation() {
 // Dodaj nawigację do stopki (przed popoverem)
 const footerLeft = document.querySelector('.footer-utilities__group--left');
 if (!footerLeft) {
 return;
 }
 
 const policyPopover = footerLeft.querySelector('anchored-popover-component');
 if (!policyPopover) {
 return;
 }
 
 // Sprawdzam czy nawigacja już istnieje
 if (document.querySelector('.policy-nav-container-footer')) {
 return;
 }
 
 // Stwórz aktywną nawigację
 const navContainer = document.createElement('div');
 navContainer.className = 'policy-nav-container-footer';
 navContainer.style.cssText = `
 background: #f8f9fa;
 border: 1px solid #e9ecef;
 border-radius: 8px;
 padding: 15px 20px;
 margin-top: 30px;
 text-align: center;
 font-size: 0.9rem;
 `;
 
 const navTitle = document.createElement('div');
 navTitle.textContent = 'Policy navigation:';
 navTitle.style.cssText = `
 color: #666;
 margin-bottom: 10px;
 font-weight: 500;
 `;
 
 const navLinks = document.createElement('div');
 navLinks.className = 'policy-nav-links';
 navLinks.style.cssText = `
 display: flex;
 flex-wrap: wrap;
 justify-content: center;
 gap: 15px;
 `;
 
 const links = [
 { text: 'Privacy Policy', url: '/policies/privacy-policy' },
 { text: 'Refund Policy', url: '/policies/refund-policy' },
 { text: 'Contact Information', url: '/policies/contact-information' },
 { text: 'Terms of Service', url: '/policies/terms-of-service' },
 { text: 'Shipping Policy', url: '/policies/shipping-policy' }
 ];
 
 links.forEach(link => {
 const linkEl = document.createElement('a');
 linkEl.href = link.url;
 linkEl.textContent = link.text;
 linkEl.style.cssText = `
 color: #666;
 text-decoration: none;
 font-weight: 500;
 padding: 8px 16px;
 border-radius: 6px;
 transition: all 0.3s ease;
 display: inline-block;
 border: 1px solid transparent;
 `;
 
 linkEl.addEventListener('mouseenter', function() {
 this.style.color = '#333';
 this.style.backgroundColor = '#fff';
 this.style.borderColor = '#666';
 this.style.transform = 'translateY(-2px)';
 this.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
 });
 
 linkEl.addEventListener('mouseleave', function() {
 this.style.color = '#666';
 this.style.backgroundColor = 'transparent';
 this.style.borderColor = 'transparent';
 this.style.transform = 'translateY(0)';
 this.style.boxShadow = 'none';
 });
 
 navLinks.appendChild(linkEl);
 });
 
 navContainer.appendChild(navTitle);
 navContainer.appendChild(navLinks);
 
 // Wstaw nawigację przed popoverem w stopce
 footerLeft.insertBefore(navContainer, policyPopover);
 
 }

 function fixGalleryProportions() {
 const galleryGrid = document.querySelector('.media-gallery__grid');
 if (!galleryGrid) return;
 
 // ZAWSZE uruchamiaj galerię w stylu Etsy na stronach produktu
 createEtsyGallery(galleryGrid);
 }
 
 // ETSY-STYLE GALLERY (miniaturki poniżej)
 function createEtsyGallery(galleryGrid) {
 // Sprawdź czy już utworzono
 if (galleryGrid.classList.contains('etsy-gallery-initialized')) {
 return;
 }
 
 // Wymuś layout flexbox pionowy (góra-dół)
 galleryGrid.style.setProperty('display', 'flex', 'important');
 galleryGrid.style.setProperty('flex-direction', 'column', 'important');
 galleryGrid.style.setProperty('gap', '16px', 'important');
 galleryGrid.style.setProperty('height', 'auto', 'important');
 galleryGrid.style.setProperty('width', '100%', 'important');
 
 // Pobierz wszystkie elementy listy (oryginalne media)
 const allImages = Array.from(galleryGrid.querySelectorAll('li'));
 if (allImages.length === 0) return;
 
 // Zapisz URL wszystkich obrazków PRZED usunięciem elementów
 const imageUrls = allImages.map(li => {
 const img = li.querySelector('img');
 if (!img) return null;
 // Spróbuj wyciągnąć URL z currentSrc, src lub srcset
 const direct = img.currentSrc || img.src || '';
 if (direct) return direct;
 const srcset = img.getAttribute('srcset') || '';
 if (srcset) {
 // Weź największy URL z srcset
 const candidates = srcset.split(',').map(s => s.trim().split(' ')[0]).filter(Boolean);
 return candidates[candidates.length - 1] || null;
 }
 return null;
 }).filter(url => url !== null && url !== '');
 
 if (imageUrls.length === 0) {
 console.warn('⏳ [ETSY] Brak gotowych obrazów (lazy-load). Spróbuję ponownie później.');
 return; // Nie usuwaj oryginalnych elementów dopóki nie mamy URLi
 }

 // Zmienna do śledzenia aktualnego indexu (globalna dla całej galerii)
 let currentIndex = 0;
 
 // NAJPIERW stwórz kontener dla głównego obrazu (będzie potrzebny w event listenerach)
 let mainImageContainer = galleryGrid.querySelector('.etsy-main-image');
 if (!mainImageContainer) {
 mainImageContainer = document.createElement('div');
 mainImageContainer.className = 'etsy-main-image';
 mainImageContainer.style.cssText = `
 width: 100%;
 position: relative;
 aspect-ratio: 1 / 1;
 background: #f5f5f5;
 border-radius: 8px;
 overflow: hidden;
 `;
 
 // Dodaj główny obraz
 const firstImage = allImages[0]?.querySelector('img');
 if (firstImage) {
 const mainImg = document.createElement('img');
 mainImg.src = firstImage.src;
 mainImg.alt = 'Main product photo';
 mainImg.style.cssText = `
 width: 100%;
 height: 100%;
 object-fit: cover;
 cursor: default;
 `;
 
 // Wyłącz zoom/modal na głównym obrazie
 mainImg.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 }, true);
 
 mainImageContainer.appendChild(mainImg);
 }
 
 // Wyłącz również kliknięcie w kontener (ale przepuść kliknięcia strzałek)
 mainImageContainer.addEventListener('click', (e) => {
 // Pozwól na kliknięcia przycisków nawigacji
 if (e.target.closest && e.target.closest('.etsy-nav-btn')) {
 return;
 }
 e.preventDefault();
 e.stopPropagation();
 }, true);
 
 // Licznik photos
 const counter = document.createElement('div');
 counter.className = 'etsy-counter';
 counter.textContent = `1 / ${imageUrls.length}`;
 counter.style.cssText = `
 position: absolute;
 bottom: 16px;
 right: 16px;
 background: rgba(0, 0, 0, 0.7);
 color: white;
 padding: 6px 12px;
 border-radius: 16px;
 font-size: 14px;
 `;
 mainImageContainer.appendChild(counter);
 
 // Strzałka LEWA na głównym obrazie
 const prevBtn = document.createElement('button');
 prevBtn.innerHTML = '‹';
 prevBtn.className = 'etsy-nav-btn prev';
 prevBtn.style.cssText = `
 position: absolute;
 left: 16px;
 top: 50%;
 transform: translateY(-50%);
 width: 40px;
 height: 40px;
 background: rgba(255, 255, 255, 0.9);
 border: none;
 border-radius: 50%;
 cursor: pointer;
 font-size: 28px;
 font-weight: bold;
 display: flex;
 align-items: center;
 justify-content: center;
 box-shadow: 0 2px 8px rgba(0,0,0,0.2);
 transition: all 0.2s ease;
 z-index: 10;
 `;
 
 // Strzałka PRAWA na głównym obrazie
 const nextBtn = document.createElement('button');
 nextBtn.innerHTML = '›';
 nextBtn.className = 'etsy-nav-btn next';
 nextBtn.style.cssText = `
 position: absolute;
 right: 16px;
 top: 50%;
 transform: translateY(-50%);
 width: 40px;
 height: 40px;
 background: rgba(255, 255, 255, 0.9);
 border: none;
 border-radius: 50%;
 cursor: pointer;
 font-size: 28px;
 font-weight: bold;
 display: flex;
 align-items: center;
 justify-content: center;
 box-shadow: 0 2px 8px rgba(0,0,0,0.2);
 transition: all 0.2s ease;
 z-index: 10;
 `;
 
 mainImageContainer.appendChild(prevBtn);
 mainImageContainer.appendChild(nextBtn);
 }
 
 // POTEM stwórz kontener dla miniaturek z nawigacją (poziomo poniżej)
 let thumbsNavigationContainer = galleryGrid.querySelector('.etsy-thumbs-navigation');
 let thumbsRow = null;
 let thumbsPrevBtn = null;
 let thumbsNextBtn = null;
 
 if (!thumbsNavigationContainer) {
 thumbsNavigationContainer = document.createElement('div');
 thumbsNavigationContainer.className = 'etsy-thumbs-navigation';
 thumbsNavigationContainer.style.cssText = `
 display: flex;
 align-items: center;
 gap: 12px;
 width: 100%;
 `;
 
 // Strzałka LEWA dla miniaturek
 thumbsPrevBtn = document.createElement('button');
 thumbsPrevBtn.innerHTML = '‹';
 thumbsPrevBtn.style.cssText = `
 width: 36px;
 height: 36px;
 background: white;
 border: 1px solid #e0e0e0;
 border-radius: 50%;
 cursor: pointer;
 font-size: 24px;
 font-weight: bold;
 display: flex;
 align-items: center;
 justify-content: center;
 flex-shrink: 0;
 box-shadow: 0 2px 4px rgba(0,0,0,0.1);
 transition: all 0.2s ease;
 `;
 
 // Kontener miniaturek
 thumbsRow = document.createElement('div');
 thumbsRow.className = 'etsy-thumbnails-row';
 thumbsRow.style.cssText = `
 display: flex;
 flex-direction: row;
 gap: 8px;
 overflow-x: auto;
 overflow-y: hidden;
 padding: 10px 0;
 flex: 1;
 scrollbar-width: none;
 -ms-overflow-style: none;
 `;
 thumbsRow.style.setProperty('-webkit-scrollbar', 'none');
 
 // Strzałka PRAWA dla miniaturek
 thumbsNextBtn = document.createElement('button');
 thumbsNextBtn.innerHTML = '›';
 thumbsNextBtn.style.cssText = `
 width: 36px;
 height: 36px;
 background: white;
 border: 1px solid #e0e0e0;
 border-radius: 50%;
 cursor: pointer;
 font-size: 24px;
 font-weight: bold;
 display: flex;
 align-items: center;
 justify-content: center;
 flex-shrink: 0;
 box-shadow: 0 2px 4px rgba(0,0,0,0.1);
 transition: all 0.2s ease;
 `;
 
 // Event listenery dla strzałek miniaturek
 if (thumbsRow) {
 thumbsPrevBtn.addEventListener('click', (e) => {
 e.preventDefault();
 thumbsRow.scrollBy({ left: -200, behavior: 'smooth' });
 });
 
 thumbsNextBtn.addEventListener('click', (e) => {
 e.preventDefault();
 thumbsRow.scrollBy({ left: 200, behavior: 'smooth' });
 });
 }
 
 // Hover effects
 [thumbsPrevBtn, thumbsNextBtn].forEach(btn => {
 if (btn) {
 btn.addEventListener('mouseenter', () => {
 btn.style.background = '#f5f5f5';
 btn.style.transform = 'scale(1.1)';
 });
 btn.addEventListener('mouseleave', () => {
 btn.style.background = 'white';
 btn.style.transform = 'scale(1)';
 });
 }
 });
 
 // Przenieś miniaturki
 if (thumbsRow) {
 allImages.forEach((img, index) => {
 const thumb = img.cloneNode(true);
 
 // Usuń wszystkie atrybuty które mogą powodować zoom/modal
 const links = thumb.querySelectorAll('a, button');
 links.forEach(link => {
 link.removeAttribute('href');
 link.removeAttribute('data-modal');
 link.removeAttribute('data-pswp-width');
 link.removeAttribute('data-pswp-height');
 link.style.pointerEvents = 'none'; // Wyłącz kliknięcia w linki
 });
 
 thumb.style.cssText = `
 width: 80px;
 height: 80px;
 border: 2px solid #e0e0e0;
 border-radius: 4px;
 cursor: pointer;
 transition: all 0.2s ease;
 flex-shrink: 0;
 `;
 
 // Dodaj active state
 if (index === 0) {
 thumb.style.borderColor = '#000';
 }
 
 // Kliknięcie zmienia główny obraz (BEZ ZOOM/MODAL)
 thumb.addEventListener('click', (e) => {
 e.preventDefault(); // Zatrzymaj domyślne zachowanie Shopify
 e.stopPropagation(); // Zatrzymaj propagację (zoom/modal)
 
 // Aktualizuj currentIndex (dla synchronizacji ze strzałkami)
 currentIndex = index;
 
 // Usuń active ze wszystkich
 thumbsRow.querySelectorAll('li').forEach(t => {
 t.style.borderColor = '#e0e0e0';
 });
 // Dodaj active
 thumb.style.borderColor = '#000';
 
 // Zmień główny obraz używając zapisanego URL
 const mainImg = mainImageContainer.querySelector('img');
 if (mainImg && imageUrls[index]) {
 mainImg.src = imageUrls[index];
 // Aktualizuj licznik
 const counter = mainImageContainer.querySelector('.etsy-counter');
 if (counter) {
 counter.textContent = `${index + 1} / ${imageUrls.length}`;
 }
 }
 }, true); // useCapture = true (przechwytuj PRZED Shopify)
 
 thumbsRow.appendChild(thumb);
 });
 }
 
 // Składaj nawigację miniaturek (tylko jeśli wszystkie elementy istnieją)
 if (thumbsNavigationContainer && thumbsPrevBtn && thumbsRow && thumbsNextBtn) {
 thumbsNavigationContainer.appendChild(thumbsPrevBtn);
 thumbsNavigationContainer.appendChild(thumbsRow);
 thumbsNavigationContainer.appendChild(thumbsNextBtn);
 
 // Dodaj NAJPIERW główny obraz (góra)
 if (mainImageContainer && !galleryGrid.querySelector('.etsy-main-image')) {
 galleryGrid.appendChild(mainImageContainer);
 }
 
 // POTEM miniaturki z nawigacją (dół)
 galleryGrid.appendChild(thumbsNavigationContainer);
 } else {
 console.warn('⚠️ [ETSY GALLERY] Nie można utworzyć galerii - brakuje elementów:', {
 thumbsNavigationContainer: !!thumbsNavigationContainer,
 thumbsPrevBtn: !!thumbsPrevBtn,
 thumbsRow: !!thumbsRow,
 thumbsNextBtn: !!thumbsNextBtn
 });
 }
 }
 
 // Event listenery dla strzałek głównego obrazu (NA ZEWNĄTRZ if'a - działają zawsze)
 const prevBtn = mainImageContainer.querySelector('.etsy-nav-btn.prev');
 const nextBtn = mainImageContainer.querySelector('.etsy-nav-btn.next');
 const counter = mainImageContainer.querySelector('.etsy-counter');
 const mainImg = mainImageContainer.querySelector('img');
 // ✅ Użyj istniejącej zmiennej thumbsRow (zadeklarowanej wcześniej) - NIE deklaruj ponownie!
 if (!thumbsRow) {
 thumbsRow = galleryGrid.querySelector('.etsy-thumbnails-row');
 }
 
 console.log('🔧 [ETSY GALLERY] Elementy znalezione:', {
 prevBtn: !!prevBtn,
 nextBtn: !!nextBtn,
 mainImg: !!mainImg,
 thumbsRow: !!thumbsRow,
 counter: !!counter
 });
 
 if (prevBtn && nextBtn && mainImg && thumbsRow) {
 // Usuń stare event listenery (klonuj przyciski)
 const newPrevBtn = prevBtn.cloneNode(true);
 const newNextBtn = nextBtn.cloneNode(true);
 prevBtn.replaceWith(newPrevBtn);
 nextBtn.replaceWith(newNextBtn);
 
 newPrevBtn.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 
 currentIndex = currentIndex === 0 ? imageUrls.length - 1 : currentIndex - 1;
 
 // Zmień obraz używając zapisanego URL
 if (mainImg && imageUrls[currentIndex]) {
 mainImg.src = imageUrls[currentIndex];
 counter.textContent = `${currentIndex + 1} / ${imageUrls.length}`;
 
 // Aktualizuj active state miniaturek
 if (thumbsRow) {
 thumbsRow.querySelectorAll('li').forEach((t, i) => {
 t.style.borderColor = i === currentIndex ? '#000' : '#e0e0e0';
 });
 }
 
 }
 });
 
 newNextBtn.addEventListener('click', (e) => {
 e.preventDefault();
 e.stopPropagation();
 
 currentIndex = currentIndex === imageUrls.length - 1 ? 0 : currentIndex + 1;
 
 // Zmień obraz używając zapisanego URL
 if (mainImg && imageUrls[currentIndex]) {
 mainImg.src = imageUrls[currentIndex];
 counter.textContent = `${currentIndex + 1} / ${imageUrls.length}`;
 
 // Aktualizuj active state miniaturek
 if (thumbsRow) {
 thumbsRow.querySelectorAll('li').forEach((t, i) => {
 t.style.borderColor = i === currentIndex ? '#000' : '#e0e0e0';
 });
 }
 
 }
 });
 
 // Hover effects dla strzałek głównego obrazu
 [newPrevBtn, newNextBtn].forEach(btn => {
 btn.addEventListener('mouseenter', () => {
 btn.style.background = 'white';
 btn.style.transform = 'translateY(-50%) scale(1.1)';
 });
 btn.addEventListener('mouseleave', () => {
 btn.style.background = 'rgba(255, 255, 255, 0.9)';
 btn.style.transform = 'translateY(-50%) scale(1)';
 });
 });
 
 } else {
 console.error('❌ [ETSY] Brak elementów:', { prevBtn, nextBtn, mainImg, thumbsRow });
 }
 
 // Usuń oryginalne elementy
 allImages.forEach(img => img.remove());
 
 galleryGrid.classList.add('etsy-gallery-initialized');
 }
 
 // STANDARD CAROUSEL (dla innych produktów)
 function createStandardCarousel(galleryGrid) {
 // UKRYJ SLIDESHOW-COMPONENT NA MOBILE (powoduje duplikację głównego zdjęcia)
 if (window.innerWidth <= 749) {
 const slideshow = document.querySelector('slideshow-component');
 if (slideshow) {
 slideshow.style.setProperty('display', 'none', 'important');
 slideshow.style.setProperty('visibility', 'hidden', 'important');
 slideshow.style.setProperty('opacity', '0', 'important');
 slideshow.style.setProperty('height', '0', 'important');
 slideshow.style.setProperty('overflow', 'hidden', 'important');
 }
 }
 
 // Dodaj aktywną nawigację na stronach polityk
 if (window.location.pathname.includes('/policies/')) {
 addPolicyNavigation();
 }
 
 // Wymuś nowe wymiary przez JavaScript - KARUZELA
 galleryGrid.style.setProperty('display', 'flex', 'important');
 galleryGrid.style.setProperty('flex-direction', 'column', 'important');
 galleryGrid.style.setProperty('height', 'auto', 'important');
 galleryGrid.style.setProperty('width', '100%', 'important');
 
 // Stwórz kontener dla miniaturek z nawigacją
 let thumbnailsContainer = galleryGrid.querySelector('.thumbnails-container');
 if (!thumbnailsContainer) {
 // Kontener z nawigacją
 const navigationContainer = document.createElement('div');
 navigationContainer.className = 'thumbnails-navigation';
 navigationContainer.style.cssText = `
 position: relative;
 display: flex;
 align-items: center;
 gap: 10px;
 `;
 
 // Przycisk lewo
 const leftBtn = document.createElement('button');
 leftBtn.innerHTML = '←';
 leftBtn.className = 'thumbnails-nav-btn left';
 leftBtn.style.cssText = `
 background: white;
 color: #333;
 border: 1px solid #e0e0e0;
 border-radius: 50%;
 width: 36px;
 height: 36px;
 cursor: pointer;
 font-size: 16px;
 display: flex;
 align-items: center;
 justify-content: center;
 flex-shrink: 0;
 box-shadow: 0 2px 4px rgba(0,0,0,0.1);
 transition: all 0.2s ease;
 `;
 
 // Kontener miniaturek
 thumbnailsContainer = document.createElement('div');
 thumbnailsContainer.className = 'thumbnails-container';
 thumbnailsContainer.style.cssText = `
 display: flex;
 gap: 10px;
 overflow-x: auto;
 padding: 10px 0;
 scroll-behavior: smooth;
 flex: 1;
 scrollbar-width: none;
 -ms-overflow-style: none;
 `;
 thumbnailsContainer.style.webkitScrollbar = 'none';
 
 // Przycisk prawo
 const rightBtn = document.createElement('button');
 rightBtn.innerHTML = '→';
 rightBtn.className = 'thumbnails-nav-btn right';
 rightBtn.style.cssText = `
 background: white;
 color: #333;
 border: 1px solid #e0e0e0;
 border-radius: 50%;
 width: 36px;
 height: 36px;
 cursor: pointer;
 font-size: 16px;
 display: flex;
 align-items: center;
 justify-content: center;
 flex-shrink: 0;
 box-shadow: 0 2px 4px rgba(0,0,0,0.1);
 transition: all 0.2s ease;
 `;
 
 // Przenieś miniaturki do kontenera
 const thumbnails = Array.from(galleryGrid.querySelectorAll('li:not(:first-child)'));
 thumbnails.forEach(thumb => {
 thumbnailsContainer.appendChild(thumb);
 });
 
 // Składaj nawigację
 navigationContainer.appendChild(leftBtn);
 navigationContainer.appendChild(thumbnailsContainer);
 navigationContainer.appendChild(rightBtn);
 
 galleryGrid.appendChild(navigationContainer);
 
 // Event listeners dla przycisków
 leftBtn.addEventListener('click', () => {
 thumbnailsContainer.scrollBy({ left: -100, behavior: 'smooth' });
 });
 
 rightBtn.addEventListener('click', () => {
 thumbnailsContainer.scrollBy({ left: 100, behavior: 'smooth' });
 });
 
 // Hover effects
 leftBtn.addEventListener('mouseenter', () => {
 leftBtn.style.background = '#f5f5f5';
 leftBtn.style.borderColor = '#ccc';
 leftBtn.style.transform = 'scale(1.05)';
 });
 
 leftBtn.addEventListener('mouseleave', () => {
 leftBtn.style.background = 'white';
 leftBtn.style.borderColor = '#e0e0e0';
 leftBtn.style.transform = 'scale(1)';
 });
 
 rightBtn.addEventListener('mouseenter', () => {
 rightBtn.style.background = '#f5f5f5';
 rightBtn.style.borderColor = '#ccc';
 rightBtn.style.transform = 'scale(1.05)';
 });
 
 rightBtn.addEventListener('mouseleave', () => {
 rightBtn.style.background = 'white';
 rightBtn.style.borderColor = '#e0e0e0';
 rightBtn.style.transform = 'scale(1)';
 });
 }
 
 // Główne zdjęcie - WYPEŁNIA CAŁĄ SZEROKOŚĆ
 const mainImage = galleryGrid.querySelector('li:first-child');
 if (mainImage) {
 // Usuń klasy które ograniczają wymiary
 mainImage.classList.remove('constrain-height', 'media-fit-contain');
 mainImage.classList.add('media-fit'); // Dodaj klasę która wypełnia
 
 mainImage.style.setProperty('height', 'auto', 'important'); // RESPONSIVE
 mainImage.style.setProperty('width', '100%', 'important');
 mainImage.style.setProperty('aspect-ratio', '1 / 1', 'important'); // KWADRAT RESPONSIVE
 mainImage.style.setProperty('grid-row', '1 / 2', 'important');
 mainImage.style.setProperty('grid-column', '1 / 4', 'important'); // WSZYSTKIE 3 KOLUMNY
 mainImage.style.setProperty('margin', '0', 'important');
 mainImage.style.setProperty('max-height', 'none', 'important');
 
 const mainImg = mainImage.querySelector('img');
 if (mainImg) {
 mainImg.style.setProperty('height', '100%', 'important'); // RESPONSIVE
 mainImg.style.setProperty('width', '100%', 'important');
 mainImg.style.setProperty('object-fit', 'cover', 'important');
 mainImg.style.setProperty('object-position', 'center', 'important');
 mainImg.style.setProperty('aspect-ratio', 'inherit', 'important'); // Dziedzicz z kontenera
 }
 }
 
 // Miniaturki - KARUZELA
 const thumbnails = thumbnailsContainer.querySelectorAll('li');
 thumbnails.forEach((thumb) => {
 // Usuń inline styles które blokują
 thumb.removeAttribute('style');
 
 // Ustaw nowe wymiary - KARUZELA
 thumb.style.setProperty('height', '90px', 'important');
 thumb.style.setProperty('width', '90px', 'important');
 thumb.style.setProperty('aspect-ratio', '1 / 1', 'important');
 thumb.style.setProperty('flex-shrink', '0', 'important'); // Nie kurcz się
 
 // Styluj kontener product-media
 const productMedia = thumb.querySelector('.product-media');
 if (productMedia) {
 productMedia.style.setProperty('width', '100%', 'important');
 productMedia.style.setProperty('height', '100%', 'important');
 productMedia.style.setProperty('aspect-ratio', '1 / 1', 'important');
 }
 
 const thumbImg = thumb.querySelector('img');
 if (thumbImg) {
 thumbImg.style.setProperty('object-fit', 'cover', 'important');
 thumbImg.style.setProperty('width', '100%', 'important');
 thumbImg.style.setProperty('height', '100%', 'important');
 }
 });
 
 }

 // Uruchom naprawę galerii po załadowaniu strony
 document.addEventListener('DOMContentLoaded', function() {
 // Czekaj aż galeria się załaduje
 setTimeout(fixGalleryProportions, 1500);
 
 // Uruchom ponownie co 500ms żeby nadpisać style Shopify
 setInterval(fixGalleryProportions, 500);
 
 // Dodaj nawigację w stopce (na wszystkich stronach)
 addPolicyNavigation();
 
 // Ukryj starą sekcję polityk
 hideOldPolicySection();
 
 // NAPRAWA POWIĘKSZONYCH ZDJĘĆ W DIALOGU
 // Event listener dla kliknięć w przyciski powiększenia
 document.addEventListener('click', function(e) {
 const zoomButton = e.target.closest('.product-media-container__zoom-button, button[class*="zoom"]');
 if (zoomButton) {
 setTimeout(fixDialogImages, 100); // Czekaj aż dialog się otworzy
 setTimeout(fixDialogImages, 300); // Ponownie po załadowaniu
 setTimeout(fixDialogImages, 600); // I jeszcze raz dla pewności
 }
 });
 
 // Regularnie sprawdzaj czy dialog jest otwarty i naprawiaj
 setInterval(fixDialogImages, 300);
 });

// account my images link
(function() {
 // Funkcja dodająca link "Moje obrazy" do menu konta klienta
 function addMyImagesLink() {
 // Sprawdź czy jesteśmy na stronie konta klienta (Shopify Customer Account API)
 const isAccountPage = window.location.hostname.includes('account.') || 
 window.location.pathname.startsWith('/account') ||
 document.querySelector('[data-customer-account]');
 
 if (!isAccountPage) {
 return;
 }

 // Sprawdź czy link już istnieje
 const existingLink = document.querySelector('a[href="/pages/my-generations"], a[href*="my-generations"]');
 if (existingLink) {
 console.log('✅ [ACCOUNT-MENU] Link "Moje obrazy" już istnieje');
 return true;
 }

 // Różne selektory dla menu konta klienta w Shopify Customer Account API
 const menuSelectors = [
 'nav[aria-label*="Account"]',
 'nav[aria-label*="Konto"]',
 'nav[role="navigation"]',
 'nav ul',
 'aside nav',
 'aside nav ul',
 '[role="navigation"] ul',
 'nav > ul',
 'ul[role="list"]'
 ];

 let menuElement = null;
 let ordersLink = null;

 // Szukaj menu i linku "Zamówienia" jednocześnie
 for (const selector of menuSelectors) {
 const elements = document.querySelectorAll(selector);
 for (const el of elements) {
 // Sprawdź czy to menu (zawiera linki)
 const links = el.querySelectorAll('a');
 if (links.length === 0) continue;

 // Szukaj linku "Zamówienia" w tym menu
 for (const link of links) {
 const text = link.textContent.trim().toLowerCase();
 if (text.includes('zamówienia') || text.includes('orders') || text.includes('order')) {
 menuElement = el;
 ordersLink = link;
 break;
 }
 }
 
 if (menuElement && ordersLink) break;
 }
 if (menuElement && ordersLink) break;
 }

 // Alternatywnie: szukaj bezpośrednio linku "Zamówienia" i znajdź jego menu
 if (!menuElement || !ordersLink) {
 const allLinks = document.querySelectorAll('nav a, aside a');
 for (const link of allLinks) {
 const text = link.textContent.trim().toLowerCase();
 if (text.includes('zamówienia') || text.includes('orders') || text.includes('order')) {
 ordersLink = link;
 menuElement = link.closest('ul') || link.closest('nav') || link.parentElement;
 break;
 }
 }
 }

 if (!menuElement || !ordersLink) {
 console.log('🔍 [ACCOUNT-MENU] Menu lub link "Zamówienia" nie znalezione');
 return false;
 }

 const ordersListItem = ordersLink.closest('li') || ordersLink.parentElement;
 if (!ordersListItem) {
 console.log('🔍 [ACCOUNT-MENU] Nie można znaleźć elementu listy dla "Zamówienia"');
 return false;
 }

 // Utwórz nowy element listy z linkiem "Moje obrazy"
 const newListItem = document.createElement('li');
 if (ordersListItem.className) {
 newListItem.className = ordersListItem.className;
 }
 
 const newLink = document.createElement('a');
 newLink.href = '/pages/my-generations';
 newLink.textContent = 'My images';
 if (ordersLink.className) {
 newLink.className = ordersLink.className;
 }
 // Skopiuj style z linku "Zamówienia"
 if (ordersLink.style.cssText) {
 newLink.style.cssText = ordersLink.style.cssText;
 }
 
 newListItem.appendChild(newLink);

 // Dodaj link po "Zamówienia"
 const parent = ordersListItem.parentElement;
 if (parent) {
 if (ordersListItem.nextSibling) {
 parent.insertBefore(newListItem, ordersListItem.nextSibling);
 } else {
 parent.appendChild(newListItem);
 }
 console.log('✅ [ACCOUNT-MENU] Link "Moje obrazy" dodany do menu konta klienta');
 return true;
 }

 return false;
 }

 // Próbuj dodać link wielokrotnie (dla dynamicznych stron Shopify Customer Account API)
 function tryAddLink() {
 const maxAttempts = 10;
 let attempts = 0;
 
 const interval = setInterval(function() {
 attempts++;
 if (addMyImagesLink() || attempts >= maxAttempts) {
 clearInterval(interval);
 }
 }, 500);
 }

 // Start gdy DOM ready
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', function() {
 tryAddLink();
 });
 } else {
 tryAddLink();
 }

 // Obserwuj zmiany w DOM (dla dynamicznych menu Shopify Customer Account API)
 const observer = new MutationObserver(function(mutations) {
 addMyImagesLink();
 });

 setTimeout(function() {
 const accountSection = document.querySelector('main') || document.querySelector('body');
 if (accountSection) {
 observer.observe(accountSection, {
 childList: true,
 subtree: true
 });
 }
 }, 1000);
 })();

// reload banner
(function(){
  if (!document.querySelector('script[src*="critical.js"]')) return;
  var timer = setTimeout(function(){
    var main = document.getElementById('MainContent');
    if (main && !main.querySelector('.section-renderer-loaded') && !document.querySelector('[data-section-renderer]')) {
      var b = document.createElement('div');
      b.id = 'customify-reload-banner';
      b.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#fff3cd;border-top:2px solid #ffc107;padding:12px 16px;text-align:center;font-family:sans-serif;font-size:14px;color:#856404;z-index:999999;display:flex;align-items:center;justify-content:center;gap:12px;';
      b.innerHTML = '<span>The page may not have loaded correctly.</span><button onclick="location.reload()" style="background:#ffc107;border:none;border-radius:6px;padding:8px 18px;font-weight:600;cursor:pointer;font-size:14px;">Refresh page</button><button onclick="this.parentElement.remove()" style="background:none;border:none;font-size:18px;cursor:pointer;color:#856404;padding:4px 8px;">✕</button>';
      document.body.appendChild(b);
    }
  }, 12000);
  window.addEventListener('load', function(){ clearTimeout(timer); });
})();
